import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Descriptions, Form, Input, message, Tag, Typography } from "antd";
import { changeMyPassword, getMyProfile } from "../services/meApi";

const ROLE_LABELS = {
  SUPER_ADMIN: "Quản trị tối cao",
  ADMIN: "Quản trị viên",
  OPERATOR: "Nhân viên nhập liệu",
  AUDITOR: "Kiểm soát viên",
};

export default function MyAccount({ currentUser }) {
  const [profile, setProfile] = useState(currentUser);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    let active = true;
    setLoading(true);
    getMyProfile()
      .then((result) => {
        if (active) setProfile(result);
      })
      .catch((error) => message.error(error.message || "Không thể tải thông tin tài khoản"))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  async function save(values) {
    setSaving(true);
    try {
      await changeMyPassword(values);
      form.resetFields();
      message.success("Đã đổi mật khẩu");
    } catch (error) {
      message.error(error.message || "Không thể đổi mật khẩu");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="management-page">
      <div className="page-heading">
        <div>
          <Typography.Title level={2}>Tài khoản của tôi</Typography.Title>
          <Typography.Text type="secondary">Xem vai trò hiện tại và tự đổi mật khẩu đăng nhập.</Typography.Text>
        </div>
      </div>

      <Card loading={loading} style={{ marginBottom: 20 }}>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Tên đăng nhập">{profile?.username || "—"}</Descriptions.Item>
          <Descriptions.Item label="Tên hiển thị">{profile?.displayName || "—"}</Descriptions.Item>
          <Descriptions.Item label="Email">{profile?.email || "—"}</Descriptions.Item>
          <Descriptions.Item label="Vai trò">{ROLE_LABELS[profile?.role] || profile?.role || "—"}</Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={profile?.status === false ? "default" : "green"}>
              {profile?.status === false ? "Đã khóa" : "Đang hoạt động"}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Đổi mật khẩu">
        <Alert
          type="info"
          showIcon
          message="Sau khi đổi mật khẩu, lần đăng nhập tiếp theo hãy dùng mật khẩu mới."
          style={{ marginBottom: 16 }}
        />
        <Form form={form} layout="vertical" onFinish={save} style={{ maxWidth: 480 }}>
          <Form.Item name="currentPassword" label="Mật khẩu hiện tại" rules={[{ required: true, message: "Nhập mật khẩu hiện tại" }]}>
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item name="newPassword" label="Mật khẩu mới" rules={[{ required: true, min: 8, message: "Mật khẩu mới tối thiểu 8 ký tự" }]}>
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Nhập lại mật khẩu mới"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Nhập lại mật khẩu mới" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) return Promise.resolve();
                  return Promise.reject(new Error("Mật khẩu nhập lại không khớp"));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={saving}>Đổi mật khẩu</Button>
        </Form>
      </Card>
    </div>
  );
}

